<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Fator de Bloqueio</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="Id do Cliente" label-for="app-client-id">
            <b-form-input id="app-client-id" v-model="application.clientId"></b-form-input>
          </b-form-group>
          <b-form-group label="Ambiente" label-for="app-provider-environment">
            <b-form-select v-model="application.provider" id="app-provider-environment">
              <option value="vault">Vault</option>
              <option value="bird">Bird</option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Fator de Bloqueio"
            label-for="lock-factor">
            <b-form-input id="lock-factor" type="number" min="1" max="10" :disabled="application.id == null" v-model="application.lockFactor"></b-form-input>
          </b-form-group>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="success" @click="find"><i class="fa fa-search"></i> Buscar</b-button>&nbsp;
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="primary" @click="save" :disabled="application.id == null"><i class="fa fa-dot-circle-o"></i> Gravar</b-button>&nbsp;
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      application: {
      },
      loadCount: 0,
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    find() {
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/lock-factor?clientId=${this.application.clientId}&provider=${this.application.provider}`)
        .then(function(response) {
          let provider = _this.application.provider
          _this.application = response.data._embedded.lock_factor[0];
          _this.application.provider = provider;
          _this.application.applicationId = _this.application.id;
          console.log('_this.application :', _this.application);
        })
        .catch(function(error) {
          _this.application.applicationId = _this.application.id = null;
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    save() {
      var _this = this;
      this.loadCount++;
      axios
        .post(`${env.urlBillingApi}/lock-factor`, this.application)
        .then(function(response) {
          var application = response.data;
          console.log(application);
          _this.$bvModal.msgBoxOk('Fator de bloqueio gravado com sucesso!')
            .then(value => {})
            .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
  }
}
</script>
